// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"5a88cb38","787":"035b129b"}[chunkId] + ".chunk.js";
};